import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "jalali-moment";
import { ReactSession } from "react-client-session";
import "./BaaHam_ContentproductionUser_Introduction.css";
import BaaHam_ContentproductionUser_IntroductionTable from "./BaaHam_ContentproductionUser_IntroductionTable";

function BaaHam_ContentproductionUser_Introduction() {
    let Tables = [
        {
            TableNumber: 1,
            FirstName: "محمد",
            LastName: "احمدی",
            PhoneNumber: "09157922402",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },

        {
            TableNumber: 2,
            FirstName: "علی",
            LastName: "احمدی",
            PhoneNumber: "09157922402",
            RemainTime: "1:97:23",
            Status: "تبدیل نشده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
        {
            TableNumber: 3,
            FirstName: "ارسلان",
            LastName: "حسینی",
            PhoneNumber: "09393544886",
            RemainTime: "15:63:23",
            Status: "تبدیل شده",
            Description: "ندارد",
        },
    ];

    const [blogPosts, setBlogPosts] = useState([]);
    useEffect(() => {
        axios
            .get("https://hammaskan.ir:8443/api/posts", {
                params: {
                    perPage: 50,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                console.log(moment(res.data.data[0].updatedAt).locale("fa").format("YYYY/MM/DD"));
                // console.log(moment(res.data.data[0].updatedAt).fromNow())
                var TablesData = [];
                // var index = 1;
                res.data.data.forEach((item, index) => {
                    TablesData.push({
                        Number: index,
                        image: item.image,
                        text: item.text,
                        title: item.title,
                        tags: item.tags,
                        writer: item.writer,
                        isDeleted: item.isDeleted,
                        active: item.active,
                        createdAt: item.createdAt,
                        updatedAt: item.updatedAt,
                        id: item.id,
                    });
                    // index++;
                    if (index === res.data.data.length - 1) {
                        setBlogPosts(TablesData);
                        console.log(TablesData);
                    }
                });
                setBlogPosts(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);

    const onchange = (data) => {
        axios
            .get("https://hammaskan.ir:8443/api/posts", {
                params: {
                    perPage: 50,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                console.log(moment(res.data.data[0].updatedAt).locale("fa").format("YYYY/MM/DD"));
                // console.log(moment(res.data.data[0].updatedAt).fromNow())
                var TablesData = [];
                // var index = 1;
                res.data.data.forEach((item, index) => {
                    TablesData.push({
                        Number: index,
                        image: item.image,
                        text: item.text,
                        title: item.title,
                        tags: item.tags,
                        writer: item.writer,
                        isDeleted: item.isDeleted,
                        active: item.active,
                        createdAt: item.createdAt,
                        updatedAt: item.updatedAt,
                        id: item.id,
                    });
                    // index++;
                    if (index === res.data.data.length - 1) {
                        setBlogPosts(TablesData);
                        console.log(TablesData);
                    }
                });
                setBlogPosts(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    };
    return (
        <div className="BaaHam_MarketerUser_Introduction">
            <p style={{ fontWeight: "bold", paddingTop: "24px" }}>لیست مطالب ایجاد شده وبلاگ</p>
            <div className="BaaHam_MU_IntroductionTables">
                <BaaHam_ContentproductionUser_IntroductionTable
                    Tables={blogPosts}
                    onchange={(e) => {
                        onchange(e);
                    }}
                />
            </div>
            <div className="FooternoneForAb"></div>
        </div>
    );
}

export default BaaHam_ContentproductionUser_Introduction;
